// @flow
import * as R from "ramda"
import { createSelector } from "reselect"
import type { Combination, Combinations } from "@kiwicom/nitro/lib/records/Baggage"

import { getGroupCombinations } from "../utils/baggageUtils"

// Need to be here, because of circular imports with passengersSelectors
const getCombinations = R.pathOr(
  {
    handBag: [],
    holdBag: [],
  },
  ["reservation", "baggage", "combinations"],
)

const getInitialCombination = (combinations: Combination[]) => {
  const sorted = R.sort((a: Combination, b: Combination) => {
    if (a.price.amount === b.price.amount) {
      return a.indices.length < b.price.amount ? -1 : 1
    }
    return a.price.amount < b.price.amount ? -1 : 1
  }, combinations)
  return sorted.length > 0 ? sorted[0].index : 0
}

export type InitialCombinations = {|
  handBag: number,
  holdBag: number,
|}

export type BaggageInitialCombinations = {|
  adult: InitialCombinations,
  child: InitialCombinations,
  infant: InitialCombinations,
|}

// eslint-disable-next-line import/prefer-default-export
export const getBaggageInitialCombinations: $FlowFixMe = createSelector(
  getCombinations,
  (combinations: Combinations) => ({
    adult: {
      handBag: getInitialCombination(getGroupCombinations("adult")(combinations.handBag)),
      holdBag: getInitialCombination(getGroupCombinations("adult")(combinations.holdBag)),
    },
    child: {
      // Same as adult for now
      handBag: getInitialCombination(getGroupCombinations("child")(combinations.handBag)),
      holdBag: getInitialCombination(getGroupCombinations("child")(combinations.holdBag)),
    },
    infant: {
      handBag: getInitialCombination(getGroupCombinations("infant")(combinations.handBag)),
      holdBag: getInitialCombination(getGroupCombinations("infant")(combinations.holdBag)),
    },
  }),
)
